module.exports = "/_next/static/images/hero-large-25d54df809bfa86a8a46fb1e28f581cb.jpg";